<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">
                {{ $t("CASH_REGISTER_READINGS.CASH_REGISTER_READINGS_LIST") }}
              </h3>
            </div>
            <div class="col-6 text-right">
              <help-button context="cash-register-readings" />
              <base-button
                type="primary"
                icon
                size="sm"
                @click="addCashRegisterReading()"
                v-if="
                  $currentUserCan(
                    $permissions.PERM_CREATE_CASH_REGISTER_READINGS
                  )
                "
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span class="btn-inner--text">{{
                  $t("CASH_REGISTER_READINGS.ADD_CASH_REGISTER_READING")
                }}</span>
              </base-button>
            </div>
          </div>
        </template>

        <cash-register-reading-list-table
          :filterEstablishment="$route.query.establishment || null"
        />
      </card>
    </div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import CashRegisterReadingListTable from "./partials/CashRegisterReadingListTable.vue";

export default {
  layout: "DashboardLayout",

  components: {
    CashRegisterReadingListTable,
    [Button.name]: Button,
  },

  mixins: [],

  computed: {},

  watch: {},

  methods: {
    addCashRegisterReading() {
      this.$router.push({ name: "Add CashRegisterReading" });
    },
  },
};
</script>
